export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-social-spotify-977560e27a9c296f3c6832190f74068f.svg";